import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';

interface Prop {
  showAll: boolean;
  setShowAll: (showAll: boolean) => void;
}

export const ViewMoreActionButton: React.FC<Prop> = ({
  showAll,
  setShowAll,
}) => {
  return (
    <div className="mt-3 text-center view_container"> 
      <button
        className="btn btn-transparent view_less"
        onClick={() => {
          setShowAll(!showAll);
        }}
      >
        {showAll ? 'View Less' : 'View More'}
      </button>
      <FontAwesomeIcon
        icon={showAll ? faArrowUp : faArrowDown}
        size="sm"
        className="icon_div"
      />
    </div>
  );
};
